// extracted by mini-css-extract-plugin
export default {"content":"_32b1eb71","contactButton":"_a00e832e"};